import { createAPI } from '@/request.js'
// 租赁订单
export const costList = data => createAPI('/api/meal/query.mt', 'post', data)
// 新增资费
export const add = data => createAPI('/api/meal/insert.mt', 'post', data)
// 资费修改
export const edit = data => createAPI('/api/meal/update.mt', 'post', data)
